/**
 * Stripe Checkout cancel redirect — sends user back to paywall.
 */
import { useEffect } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useRouter } from 'expo-router';
import { useTheme } from '@/contexts/ThemeContext';
import { TYPO } from '@/constants/typography';

export default function CheckoutCancel() {
  const router = useRouter();
  const { theme } = useTheme();
  const c = theme.colors;

  useEffect(() => {
    const timer = setTimeout(() => {
      router.replace('/paywall');
    }, 1500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <View style={[styles.container, { backgroundColor: c.background }]}>
      <Text style={[styles.heading, { color: c.text }]}>Payment Cancelled</Text>
      <Text style={[styles.sub, { color: c.textSecondary }]}>Redirecting back to plans...</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, justifyContent: 'center', alignItems: 'center', padding: 24 },
  heading: { fontSize: 22, fontFamily: TYPO.heading.bold, marginBottom: 8 },
  sub: { fontSize: 14, fontFamily: TYPO.body.regular },
});
